function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext, memo, forwardRef } from 'react';
import { SWMIconContext } from './context';
import { iconType } from '../types';

const createIcon = Component => {
  const IconWrapper = /*#__PURE__*/forwardRef(({
    color,
    strokeWidth,
    size,
    set,
    style,
    ...props
  }, ref) => {
    const context = useContext(SWMIconContext);
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: size || context.size,
      height: size || context.size,
      fill: "none",
      viewBox: "0 0 24 24",
      style: style
    }, props, {
      ref: ref
    }), /*#__PURE__*/React.createElement(Component, {
      color: color || context.color,
      strokeWidth: strokeWidth || context.strokeWidth,
      set: set || context.set
    }));
  });
  IconWrapper.propTypes = {
    props: iconType
  };
  const MemoIcon = /*#__PURE__*/memo(IconWrapper);
  return MemoIcon;
};

export default createIcon;